export const cdnUrl = (url) => {
    if (!url) return url;
    return url.replace(
        'https://directitwebicons.blob.core.windows.net/img/',
        'https://cdn.directx.ca/'
    );
};

export const toISODateTime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const MM = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const HH = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}`;
};

export const TIMEZONE_MAP = {
    "Pacific Standard Time": "America/Los_Angeles",
    "Mountain Standard Time": "America/Edmonton",
    "Central Standard Time": "America/Chicago",
    "Eastern Standard Time": "America/New_York",
    "Atlantic Standard Time": "America/Halifax",
    "Newfoundland Standard Time": "America/St_Johns",
};

export const getIanaTimezone = (tz) => {
    return TIMEZONE_MAP[tz] || "";
};

export const formatDateForTimezone = (utcDateStr, tz) => {
    if (!utcDateStr) return "";
    try {
        const ianaZone = getIanaTimezone(tz);
        if (!ianaZone) return utcDateStr.substring(0, 19).replace("T", " ");
        const d = new Date(utcDateStr);
        return d.toLocaleString("sv-SE", {
            timeZone: ianaZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch (e) {
        return utcDateStr.substring(0, 19).replace("T", " ");
    }
};
